import { configureStore, createSlice, combineReducers } from "@reduxjs/toolkit";

// globalConfigSlice

const globalConfigSlice = createSlice({
  name: "globalConfigSlice",

  initialState: {
    api: "http://localhost:8080",
    theme: "dark",
  },

  reducers: {
    setApi(state, action) {
      state.api = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
  },
});

const rootReducers = combineReducers({
  globalConfig: globalConfigSlice.reducer,
});

const store = configureStore({
  reducer: rootReducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const globalConfigActions = globalConfigSlice.actions;

export default store;
